/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-display-colors',
  templateUrl: './theme-option-tooltips-display-colors.component.html',
  styleUrls: ['./theme-option-tooltips-display-colors.component.css']
})
export class ThemeOptionTooltipsDisplayColorsComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_displayColors';

  constructor() {}

  receiveValue(value: boolean) {
    this.themeOptions.setOption('tooltips_displayColors', value);
  }

}
